var _templateObject = _taggedTemplateLiteralLoose(['background-color: ', '; color: #FFFFFF'], ['background-color: ', '; color: #FFFFFF']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';
import { css } from 'emotion';

import { RXBlock, RXBlockStatus, RXBlockColor } from './RXBlock';

export var RXModalColor = {
    PRIMARY: '#20a8d8',
    SECONDARY: '#c8ced3',
    SUCCESS: '#4dbd74',
    INFO: '#63c2de',
    WARNING: '#ffc107',
    DANGER: '#f86c6b',
    LIGHT: '#f0f3f5',
    DARK: '#2f353a'
};

export var RXModalSize = {
    LARGE: "lg",
    SMALL: "sm",
    NORMAL: ""
};

var logdown = require('logdown');
var console = logdown('rx-core-modal', { prefixColor: '#d84315' });

export var RXModal = function (_Component) {
    _inherits(RXModal, _Component);

    function RXModal(props) {
        _classCallCheck(this, RXModal);

        // console.log(`log props: ${JSON.stringify(this.props)}`);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.onOpenedModal = function () {
            console.log('in onOpenedModal');
            if (_this.props.onLoad) {
                _this.props.onLoad();
            }
        };

        _this.doClose = function () {

            _this.props.onClose();
        };

        _this.onToggle = function () {
            console.log('in ontoggle');
            _this.props.toggle();
        };

        var size = _this.props.size === undefined ? RXModalSize.NORMAL : _this.props.size;

        // console.log(`log props: ${JSON.stringify(this.props)}`);
        _this.state = {
            headerColor: _this.props.headerColor,
            buttonDisabled: true,
            size: size,
            show: _this.props.show,
            blockStatus: RXBlockStatus.HIDE,
            blockColor: _this.props.blockColor,
            blockMessage: ""
        };
        _this.headerClass = css(_templateObject, _this.state.headerColor);
        return _this;
    }

    RXModal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

        if (this.props.size != prevProps.size) {
            this.setState({ size: this.props.size });
        }
        if (this.props.show != prevProps.show) {
            console.log('in componentDidUpdate with ' + this.props.show);
            this.setState({ show: this.props.show });
        }
        if (this.props.blockStatus != prevProps.blockStatus) {
            console.log('in componentDidUpdate with ' + this.props.blockStatus);
            this.setState({ blockStatus: this.props.blockStatus });
        }
        if (this.props.backdrop != prevProps.backdrop) {
            console.log('in componentDidUpdate with ' + this.props.backdrop);
            this.setState({ backdrop: this.props.backdrop });
        }
    };

    RXModal.prototype.render = function render() {

        var externalCloseBtn = React.createElement(
            'button',
            { className: 'close', style: { position: 'absolute', top: '15px', right: '15px' }, onClick: this.toggle },
            '\xD7'
        );

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(
                Modal,
                { backdrop: this.props.backdrop, isOpen: this.state.show, external: externalCloseBtn, toggle: this.onToggle, onOpened: this.onOpenedModal, size: this.state.size },
                React.createElement(
                    ModalHeader,
                    { className: this.headerClass, style: { display: 'flex', justifyContent: 'center' } },
                    this.props.title
                ),
                React.createElement(
                    ModalBody,
                    null,
                    React.createElement(
                        RXBlock,
                        { status: this.state.blockStatus, color: this.state.blockColor, message: this.state.blockMessage },
                        this.props.children
                    )
                ),
                React.createElement(
                    ModalFooter,
                    null,
                    this.props.footer
                )
            )
        );
    };

    return RXModal;
}(Component);

RXModal.defaultProps = {
    headerColor: RXModalColor.PRIMARY,
    blockColor: RXModalColor.PRIMARY,
    backdrop: true

    // module.exports = {
    //     RXModal: RXModal,
    //     RXModalColor: RXModalColor,
    //     RXModalSize: RXModalSize
    // }

};